module.exports = __webpack_public_path__ + "static/media/SLIGHTLY_LEFT.2761ef8a.svg";